import React from 'react';
import {
  TouchableOpacity,
  Text,
  StyleSheet,
  ViewStyle,
  StyleProp,
} from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { MOBILE_TEXT_STYLES } from '@/constants/residents/mobile/mobileTypography';

interface BackLinkProps {
  /** Text to display (e.g., "Back to all resources") */
  label: string;
  /** Handler when link is pressed */
  onPress: () => void;
  /** Custom color for the link (default: #6B8EFE) */
  color?: string;
  /** Icon size (default: 20) */
  iconSize?: number;
  /** Custom container style */
  style?: StyleProp<ViewStyle>;
  /** Accessibility label override */
  accessibilityLabel?: string;
}

/**
 * BackLink
 * 
 * Reusable back navigation link component with chevron icon.
 * Matches Figma design for detail screens.
 * 
 * @example
 * <BackLink
 *   label="Back to all resources"
 *   onPress={() => navigation.goBack()}
 * />
 */
export const BackLink: React.FC<BackLinkProps> = ({
  label,
  onPress,
  color = '#6B8EFE',
  iconSize = 20,
  style,
  accessibilityLabel,
}) => {
  return (
    <TouchableOpacity
      style={[styles.container, style]}
      onPress={onPress}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel || label}
    >
      <Icon name="chevron-back" size={iconSize} color={color} />
      <Text style={[styles.text, { color }]}>{label}</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    ...MOBILE_TEXT_STYLES.linkBlue,
  },
});

export default BackLink;
